import axios from 'axios'
import { Message } from 'element-ui'
import router from '@/router'
import DOMAIN from '@/config/domain'

axios.defaults.withCredentials = true
const service = axios.create({
  baseURL: DOMAIN.WEBSITE,
  timeout: 10000
})

service.interceptors.request.use(
  config => {
    return config
  },
  error => {
    return Promise.reject(error)
  }
)

service.interceptors.response.use(
  response => {
    const res = response.data
    if (res.status !== 1) {
      return Promise.reject(res.msg)
    } else {
      return res.data
    }
  },
  error => {
    const path = router.currentRoute.fullPath
    if (error.response.status === 401) {
      Message({
        message: '登录状态失效，请登录！',
        type: 'error',
        duration: 2 * 1000
      })
      console.log('path:', path)
      router.push('/login')
      return Promise.reject(error)
    } else {
      Message({
        message: error.response.data.msg || '数据错误',
        type: 'error',
        duration: 6 * 1000
      })
      router.push('/login')
      return Promise.reject(error)
    }
  }
)

export default service
